<template>
  <div class="room-doc-progress-toast-component">
    <div class="room-status-msg-views">
      <template v-for="uploadRoomDoc in uploadRoomDocFiles">
        <div class="room-status-msg" 
            :key="uploadRoomDoc.id" 
            v-if="uploadRoomDoc.id && uploadRoomDoc.percent <= 100"
            >
          <div class="room-status-msg-wrapper">
            <div class="room-status-body">
              <div class="room-status-msg-text-wrapper">
                <div class="room-status-msg-text">{{ uploadRoomDoc.filename }}</div>
                <div class="room-status-progress">
                  <div class="room-status-progress-text">{{ uploadRoomDoc.percent }}%</div>
                  <div class="room-status-progressBg"></div>
                  <div class="room-status-progress-bar" :style="{width: `${uploadRoomDoc.percent}%`}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-for="roomDocFile in roomDoc.roomDocFiles">
        <div class="room-status-msg" 
          :key="roomDocFile.docId" 
          v-if="roomDocFile.docFile && (roomDocFile.docFile.docState === 0 || roomDocFile.docFile.docState === 1)"
          >
          <div class="room-status-msg-wrapper">
            <div class="room-status-body">
              <div class="room-status-msg-text-wrapper">
                <div class="room-status-msg-text">{{ roomDocFile.docName }}</div>
                <div class="room-status-progress">
                  <div v-if="roomDocFile.docFile.docState === 1" class="room-status-progress-text">{{ roomDocFile.docFile.docConvPageCnt }}/{{ roomDocFile.docFile.docPageCnt > 0 ? roomDocFile.docFile.docPageCnt : '...' }}</div>
                  <div v-else-if="roomDocFile.docFile.docState === 0" class="room-status-progress-text">{{ $t("doc.list.transform.ready") }}</div>
                  <div class="room-status-progressBg"></div>
                  <div class="room-status-progress-bar"
                       v-if="roomDocFile.docFile.docPageCnt > 0"
                       :style="{width: `${roomDocFile.docFile.docConvPageCnt / roomDocFile.docFile.docPageCnt * 100}%`}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  computed: {
    ...mapState('doc', [
      'uploadRoomDocFiles'
    ]),
    ...mapGetters('doc', [
      'roomDoc'
    ]),
  }
}
</script>

<style lang="scss" scoped>
.room-doc-progress-toast-component{
  position: absolute;
	right: 2px;
	bottom: 2px;
	z-index: 10;
	display: table;
	width: 200px;
	height: 100%;
	padding: 2px;
	overflow: hidden;
	pointer-events: none;

  .room-status-msg-views {
		display: table-cell;
		width: inherit;
		vertical-align: bottom;
	}

  .room-status-msg {
  display: block;
  width: inherit;
  height: 70px;
  margin-top: 5px;
  padding: 0;
  box-sizing: border-box;
  border-radius: 5px;
  background: linear-gradient(to bottom, #03f, #07f);
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  font-size: 1rem;
  color: #2b2b2b;
  pointer-events: auto;
  cursor: default;
  animation-duration: 0.4s;
  animation-name: slide-left;

    .room-status-msg-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .room-status-icon {
      position: absolute;
      top: 0;
      width: 50px;
      height: 100%;
      background: url("~@/assets/images/alert_blue.svg") center no-repeat;
      background-size: 50%;
    }

    .room-status-body {
      padding-left: 50px;
      height: 100%;
    }

    .close {
      position: absolute;
      right: 2px;
      top: 2px;
      width: 18px;
      height: 18px;
      border-radius: 50%;

      &:hover {
        background-color: rgba(199,199,199,0.5);
      }

      &:before, &:after {
        content: '';
        position: absolute;
        left: 47%;
        width: 2px;
        height: 60%;
        background-color: #0cf;
      }
      &:before {
        transform: rotate(45deg);
        top: 20%;
      }
      &:after {
        transform: rotate(-45deg);
        bottom: 20%;
      }
    }

    .room-status-body {
      padding: 0;
    }

    .room-status-msg-text-wrapper {
      width: 100%;
      height: 100%;
      line-height: 15px;
    }
    .room-status-msg-text {
      padding: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: yellow;
      font-size: 12px;
    }

    .room-status-progress {
      position: absolute;
      top: 10px;
      left: 10px;
      width: calc(100% - 20px);
      height: calc(100% - 20px);
      margin: 0;
      box-sizing: border-box;
      background-color: transparent;
      border: none;
      border-radius: 0;
      text-align: left;
      overflow: initial;

      .room-status-progress-text {
        position: absolute;
        right: 0;
        bottom: 14px;
        height: auto;
        padding: 0;
        color: white;
        font-size: 16.8px;
        line-height: 1;
      }

      .room-status-progressBg, .room-status-progress-bar {
        position: absolute;
        bottom: 0;
        height: 4px;
        border-radius: 2px;
      }

      .room-status-progressBg {
        width: 100%;
        background-color: rgba(0,0,0,0.2);
      }

      .room-status-progress-bar {
        background-color: white;
      }
    }
  }
}

</style>